






import { defineComponent, ref } from "@vue/composition-api";
import { NSFWSettingsSubjectType } from "@scrile/api-provider/dist/api/NSFWSettingsProvider";
import providers from "@/lib/api";
import config from "@/config";
import BaseSwitch from "@/components/BaseSwitch";

export default defineComponent({
  name: "SafeForWorkToggle",
  components: { BaseSwitch },
  props: {
    postId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const status = ref(false);

    const getStatus = async () => {
      if (!config.featureNSFW) return;
      const response = await providers.NSFWSettingsProvider.search({
        data: { subjects: [{ subjectId: props.postId, subjectType: NSFWSettingsSubjectType.POST }] },
      });
      status.value = response.length ? response[0].safeForWork : false;
    };

    const updateSFW = async () => {
      if (!config.featureNSFW) return;
      await providers.NSFWSettingsProvider.update({
        data: {
          subject: { subjectId: props.postId, subjectType: NSFWSettingsSubjectType.POST },
          safeForWork: status.value,
        },
      });
    };

    getStatus();
    emit("setUpdateCb", updateSFW);

    return { status, config };
  },
});
